/*
 * Vencord, a modification for Discord's desktop app
 * Copyright (c) 2022 Vendicated and contributors
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

(window.VencordStyles ??= new Map()).set("src/plugins/imageZoom/styles.css", {
    name: "src/plugins/imageZoom/styles.css",
    source: ".vc-imgzoom-lens {\n    position: absolute;\n    inset: 0;\n    z-index: 9999;\n    border: 2px solid grey;\n    border-radius: 50%;\n    overflow: hidden;\n    cursor: none;\n    box-shadow: inset 0 0 10px 2px grey;\n    filter: drop-shadow(0 0 2px grey);\n    pointer-events: none;\n\n    /* negate the border offsetting the lens */\n    margin: -2px;\n}\n\n.vc-imgzoom-square {\n    border-radius: 0;\n}\n\n.vc-imgzoom-nearest-neighbor > .vc-imgzoom-image {\n    image-rendering: pixelated;\n\n    /* https://googlechrome.github.io/samples/image-rendering-pixelated/index.html */\n}\n",
    classNames: {},
    dom: null,
});

export default "src/plugins/imageZoom/styles.css";
